import * as React from "react"
import { Link, navigate } from "gatsby"
import { graphql } from 'gatsby'

import { Router } from "@reach/router"

import Layout from "../components/layout"
import SEO from "../components/seo"
import PageHeading from "../components/styled/page-heading"

import useAuth from "../hooks/useAuth"

import './index.css'
import './login.css'
import '../components/catlist.css'

const App = ( { location } ) => {
  const seo = { title: "LoggedIn"}

  console.log(location)
  console.log(location.pathname)
  
  const { state, isAuthenticated } = useAuth()
  const redirect = location.pathname.split('/').pop()
  React.useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { state: { redirect }});
    }
  }, [isAuthenticated, redirect]);

  return (
    <div id="lay">
      <Layout>
        <SEO seo={seo} />
        <PageHeading>Welcome!</PageHeading>
    
        <br/><br/>
       
          <div id="loglinkbox">Thank you for signing up! Full Database coming soon!</div>
      </Layout>
    </div>
  )
}

export default App